import BM from '@src/assets/images/bibme-logo.svg'
import CM from '@src/assets/images/cm_main_logo.svg'
import EB from '@src/assets/images/easybib-chegg-logo.svg'
import { selectAltLogoText, selectLogoUrl } from '@src/state/site/selectors'
import { BIBME, CITATION_MACHINE, EASYBIB, SiteState } from '@src/state/site/types'
import { RootState } from '@src/state/types'
import media, { PHONE_DOUBLE_ZOOM } from '@src/styled/media'
import * as React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

interface LogoProps {
  site?: SiteState
  alt: string
  href: string
}

const EasyBibLogo = styled.a<LogoProps>`
  display: inline-block;
  width: 112px;
  height: 32px;
  position: relative;
  background: url(${EB}) top center no-repeat;
  background-size: contain;
  ${media[PHONE_DOUBLE_ZOOM]`
    height: 20px;
    width: 100%;
    min-width: 60px;
  `}
`

const CitationMachineLogo = styled(EasyBibLogo)<LogoProps>`
  margin-left: ${({ theme }) => theme.spacing.md3};
  background: url(${CM}) top center no-repeat;
  width: 170px;
  background-size: contain;
`

const BibMeLogo = styled(EasyBibLogo)<LogoProps>`
  margin-left: 20px;
  background: url(${BM}) top center no-repeat;
  background-size: contain;
`

export const Logo = (props: LogoProps) => {
  switch (props.site) {
    case EASYBIB:
      return <EasyBibLogo aria-label={props.alt} {...props} />
    case BIBME:
      return <BibMeLogo aria-label={props.alt} {...props} />
    case CITATION_MACHINE:
      return <CitationMachineLogo aria-label={props.alt} {...props} />
    default:
      return null
  }
}

const mapStateToProps = (state: RootState): LogoProps => ({
  site: state.site,
  href: selectLogoUrl(state),
  alt: selectAltLogoText(state),
})

export default connect(mapStateToProps)(Logo)



// WEBPACK FOOTER //
// ./src/components/Header/Logo.tsx